import React,{useState, useEffect}  from 'react';

import Sides from '../Bars/Pythonsidebar';
 
import { Helmet } from "react-helmet";

import Button from 'react-bootstrap/Button'
function Ptypevar(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
 
return(
     <div>
<Sides/>

<Helmet>
 
  <title>Learn Free Python Types of Variables Loop Beginners Tutorials CodeExampler</title>
<meta name="description" content="Python Type of variable tutorial for beginners.CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners and questions of all technology like Python tutorial, Python tutorial,Python tutorial for beginners in deeply knowledge With Deeply" />
<meta name="keywords" content="codeexampler,programming language,Math function in Python,local variable in python,Global variable in python,tutorial for begineers,Type of variable in python,How to get type of variable in python,How to Check type of variable in python,How to find type of variable in python" />
<link rel="canonical" href="https://www.codeexampler.com/python-types-of-variable/" />
</Helmet>

<div className='lg:pl-56'>

    <h1 className="m-4 mh1">Type of variables in python</h1>

    <div className="first">
        <a href="/python-variables">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/python-identifiers">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>

    <h2 className="mt-4 mh2">How to get the type of variable in python</h2>
<h3 className="mt-4 mh3">Variables are 2 Types in Python :</h3>
<h4 className="mt-4">1, Local Variable in Python<br/>
2, Global Variable in python
</h4>
<h2 className="mt-4 mh2">1,Local Variable in Python:</h2>
<p className="mt-4 para">Local Variable in Python are defined inside a function and can’t be used  from outside that function</p>



       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
      <pre style={{maxHeight:"500vh"}}>
          <code >
            {"\n"}
            <span className="qwerty">def </span>
                <span className="qwerty-2">display</span>
                <span className="qwerty-10">()</span>
                <span className="qwerty-1">:</span>
            {"\n"}
                <span className="qwerty-4">    x</span>
                <span className="qwerty-1">=</span>
                <span className="qwerty-8">100</span>
                <span className="qwerty-10"> # local variable</span>
                {"\n"}                
                <span className="qwerty-3">    print</span>
                <span className="qwerty-10">(</span>
                <span className="qwerty-4">x</span>
                <span className="qwerty-10">)</span>
                {"\n"}
                <span className="qwerty-4">x</span>
                <span className="qwerty-1">=</span>
                <span className="qwerty-8">20</span>
                <span className="qwerty-10"> # global variable</span>
                {"\n"}
                <span className="qwerty-2">display</span>
                <span className="qwerty-10">()</span>

            {"\n"}                                
                <span className="qwerty-3">print</span>
                <span className="qwerty-10">(</span>
                <span className="qwerty-4">x</span>
                <span className="qwerty-10">)</span>
            {"\n"}{"\n"}
                 </code>
        </pre>
        </div>          
        <h5 className='headings'> Output : </h5>
         <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
            <pre style={{maxHeight:"100vh"}}>
                <code >
                    {"\n"}
                        <span className="qwerty-9">100</span>
                    {"\n"}
                        <span className="qwerty-6">20</span>
                        {"\n"}      {"\n"}      
              </code>
                </pre>
                </div>


<h2 className="mt-4 mh2">2, Global Variable in Python</h2>
<p className="mt-4 para">Global Variable in Python are defined from outside the function and can be used anywhere in the program. The initial value will be zero and the global keyword is used to a defined variable as global
</p>



<h2 className='headings'>Global Variable in Python Example:</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
             <span className="qwerty">def </span>
                 <span className="qwerty-2">display</span>
                 <span className="qwerty-10">()</span>
                 <span className="qwerty-1">:</span>
             {"\n"}
                 <span className="qwerty-7">    global</span>
                 <span className="qwerty-4"> x</span>
             {"\n"}
                 <span className="qwerty-4">    c</span>
                 <span className="qwerty-1">=</span>
                 <span className="qwerty-8">100</span>
             {"\n"}
                 <span className="qwerty-4">    x</span>
                 <span className="qwerty-1">=</span>
                 <span className="qwerty-8">100</span>
                 {"\n"}                
                 <span className="qwerty-3">    print</span>
                 <span className="qwerty-10">(</span>
                 <span className="qwerty-4">x</span>
                 <span className="qwerty-10">)</span>
                 {"\n"}
                 <span className="qwerty-4">    x</span>
                 <span className="qwerty-1">=</span>
                 <span className="qwerty-4">x</span>
                 <span className="qwerty-6">+</span>
                 <span className="qwerty-8">100</span>
                 {"\n"}
                 <span className="qwerty-4">x</span>
                 <span className="qwerty-1">=</span>
                 <span className="qwerty-8">20</span>
                 {"\n"}
                 <span className="qwerty-2">display</span>
                 <span className="qwerty-10">()</span>
                 
             {"\n"}                                
                 <span className="qwerty-3">print</span>
                 <span className="qwerty-10">(</span>
                 <span className="qwerty-4">x</span>
                 <span className="qwerty-10">)</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>          
         <h5 className='headings'> Output : </h5>
          <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
             <pre style={{maxHeight:"100vh"}}>
                 <code >
                     {"\n"}
                         <span className="qwerty-9">100</span>
                     {"\n"}
                         <span className="qwerty-9">200</span>
                         {"\n"}      {"\n"}      
               </code>
                 </pre>
                 </div>


<h2 className="mt-4 mh2">Type of Conversion in Python:</h2>

        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
             <span className="qwerty-9">&#62;</span>
             <span className="qwerty-9">&#62;</span>
             <span className="qwerty-9">&#62; </span>
                 <span className="qwerty-4">1</span>
                 <span className="qwerty"> + </span>
                 <span className="qwerty-7">2.0</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-7">3.0</span>
             {"\n"}
             <span className="qwerty-9">&#62;</span>
             <span className="qwerty-9">&#62;</span>
             <span className="qwerty-9">&#62; </span>
                 <span className="qwerty-3">int</span>
                 <span className="qwerty-10">(</span>
                 <span className="qwerty-7">2.0</span>
                 <span className="qwerty-10">)</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-4">2</span>
             {"\n"}
             <span className="qwerty-9">&#62;</span>
             <span className="qwerty-9">&#62;</span>
             <span className="qwerty-9">&#62; </span>
                 <span className="qwerty-3">float</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-4">20</span>
                 <span className="qwerty-1">)</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-7">20.0</span>
             {"\n"}
             <span className="qwerty-9">&#62;</span>
             <span className="qwerty-9">&#62;</span>
             <span className="qwerty-9">&#62; </span>
                 <span className="qwerty-6">print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-1">'</span>
                 <span className="qwerty-8">2.5</span>
                 <span className="qwerty-1">'</span>
                 <span className="qwerty"> + </span>
                 
                 <span className="qwerty-1">'</span>
                 <span className="qwerty-8">4.5</span>
                 <span className="qwerty-1">'</span>
                 <span className="qwerty-1">)</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-2">2.5 4.5</span>
             {"\n"}
             <span className="qwerty-9">&#62;</span>
             <span className="qwerty-9">&#62;</span>
             <span className="qwerty-9">&#62; </span>
             <span className="qwerty-6">print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-7">2.5</span>
                 <span className="qwerty"> + </span>
                 <span className="qwerty-3">float</span>
                 <span className="qwerty-1">(</span>
                <span className="qwerty-1">'</span>
                 <span className="qwerty-7">4.0</span>
                 <span className="qwerty-1">'</span>
                 <span className="qwerty-1">)</span>
                 <span className="qwerty-1">)</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-7">6.5</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div> 


<h2 className="mt-4 mh2">Python Decimal </h2>


<h2 className='headings'>Q-Types of Conversion in Python Example?</h2>
       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
      <pre style={{maxHeight:"500vh"}}>
          <code >
            {"\n"}
            <span className="qwerty">print</span>
                 <span className="qwerty-10">(</span>
                 <span className="qwerty-7">1.1</span>
                 <span className="qwerty"> + </span>
                 <span className="qwerty-7">2.2</span>
                 <span className="qwerty-10">)</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-4">3.300000000000003</span>
            {"\n"}
            <span className="qwerty">print</span>
                 <span className="qwerty-10">(</span>
                 <span className="qwerty-1">'</span>
                 <span className="qwerty-8">1.1</span>
                 <span className="qwerty-1">'</span>
                 <span className="qwerty"> + </span>
                 <span className="qwerty-1">'</span>
                 <span className="qwerty-8">2.2</span>
                 <span className="qwerty-1">'</span>
                 <span className="qwerty-10">)</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-3">1.1 2.2</span>
            {"\n"}{"\n"}
                 </code>
        </pre>
        </div>

<h2 className="mt-4 mh2">Import Math function in Python:</h2>



        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
             <span className="qwerty">import </span>
                 <span className="qwerty-4">math</span>
             {"\n"}
                 <span className="qwerty-6">print</span>
                 <span className="qwerty-10">(</span>
                 <span className="qwerty-4">math</span>
                 <span className="qwerty-1">.</span>
                 <span className="qwerty-7">pi</span>
                 <span className="qwerty-10">)</span>
                 {"\n"}
                 <span className="qwerty-8">    OR</span>
                 {"\n"}
                 <span className="qwerty-6">print</span>
                 <span className="qwerty-10">(</span>
                 <span className="qwerty-4">math</span>
                 <span className="qwerty-1">.</span>
                 <span className="qwerty-7">sqrt</span>
                 <span className="qwerty-6">(</span>
                 <span className="qwerty-1">16</span>
                 <span className="qwerty-6">)</span>
                 <span className="qwerty-10">)</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>        
         <h5 className='headings'> Output : </h5>
          <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
             <pre style={{maxHeight:"100vh"}}>
                 <code >
                     {"\n"}
                         <span className="qwerty-9">3.141592653589793</span>
                     {"\n"}
                         <span className="qwerty-10">4.0</span>
                         {"\n"}      {"\n"}      
               </code>
                 </pre>
                 </div>

  <h1 className="mt-5">  </h1>
  <div className="back">
        <a href="/python-variables">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/python-identifiers">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
    </div>
)

}
export default Ptypevar;